export default function campaign (Restangular) {
  'ngInject'
  return Restangular.all('campaign')
}
